import React from 'react';
import { Link } from 'react-router-dom';

const About = () => {
  return (
    <section id="about" className="about section">
      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="row gy-5 align-items-center">
          <div className="col-lg-5" data-aos="fade-right" data-aos-delay="200">
            <div className="content">
              <h6 className="subtitle" data-aos="fade-up" data-aos-delay="250">Discover Our Story</h6>
              <h2 data-aos="fade-up" data-aos-delay="300">Innovative Solutions for a Digital-First World</h2>
              <p data-aos="fade-up" data-aos-delay="350">
                Rettiyon Global is a technology partner that helps businesses modernize, scale, and secure their digital infrastructure. We deliver custom software, cloud migration, and enterprise integrations—backed by certified engineers and proven delivery practices.
              </p>

              <ul className="features-list">
                <li data-aos="fade-up" data-aos-delay="400"><i className="bi bi-check-circle-fill"></i><span>Enterprise-grade software development and system integration.</span></li>
                <li data-aos="fade-up" data-aos-delay="450"><i className="bi bi-check-circle-fill"></i><span>Cloud-native architecture and DevOps automation.</span></li>
                <li data-aos="fade-up" data-aos-delay="500"><i className="bi bi-check-circle-fill"></i><span>Agile delivery with transparent timelines and fixed-scope options.</span></li>
              </ul>

              <Link to="/about" className="btn btn-primary" data-aos="fade-up" data-aos-delay="550">Discover More</Link>
            </div>
          </div>

          <div className="col-lg-7" data-aos="fade-left" data-aos-delay="300">
            <div className="image-composition">
              <div className="image-main" data-aos="zoom-in" data-aos-delay="400">
                <img src="/images/about-9.webp" alt="Modern office with a team working" className="img-fluid" loading="lazy" />
              </div>
              <div className="image-secondary" data-aos="zoom-in" data-aos-delay="500">
                <img src="/images/about-square-8.webp" alt="Collaborative discussion" className="img-fluid" loading="lazy" />
              </div>
              <div className="stats-card" data-aos="fade-up" data-aos-delay="600">
                <div className="stats-item">
                  <h3>20+</h3>
                  <p>Years of Expertise</p>
                </div>
                <div className="stats-item">
                  <h3>500+</h3>
                  <p>Happy Clients</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
